import RoleLinkCard, { type RoleLinkCardItem } from './RoleLinkCard';

type RoleLinkCardGridProps = {
  items: RoleLinkCardItem[];
  to?: string;
  variant?: 'light' | 'dark';
  /** Narrow stacked tiles (Home); default is wide horizontal cards. */
  layout?: 'horizontal' | 'stacked';
  /** Desktop column count when stacked (e.g. 6 roles, 5 industries). */
  columns?: number;
  className?: string;
};

/** Responsive grid of {@link RoleLinkCard} tiles — Home roles/industries, etc. */
export default function RoleLinkCardGrid({
  items,
  to,
  variant = 'light',
  layout = 'horizontal',
  columns,
  className = '',
}: RoleLinkCardGridProps) {
  const stacked = layout === 'stacked';
  const gridClass = [
    'sbr-role-link-grid',
    stacked && 'sbr-role-link-grid--stacked',
    stacked && columns && `sbr-role-link-grid--cols-${columns}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={gridClass} role="list">
      {items.map((item) => (
        <div key={item.title} role="listitem">
          <RoleLinkCard item={item} to={to} variant={variant} layout={layout} />
        </div>
      ))}
    </div>
  );
}
